<mat-sidenav-container>

  <mat-sidenav-content [ngClass]="sidenavRef?.opened ? 'sidenav-opened':'sidenav-closed'">
    <div *ngIf="(renderNav$ | async)"
          class="mobile-top-bar d-flex align-items-center d-lg-none" (scroll)="onScrollEvent($event)"
         [ngClass]=" {'fixed' : (scrollOffset > 0)} ">
      <div class="col p-0 d-flex" (click)="sidenavRef?.toggle()">
        <button mat-icon-button><i class="fas fa-bars"></i></button>
      </div>
      <div class="col col-auto text-center" (click)="sidenavRef?.toggle()">
        <img src="/assets/img/videobyte-logo.svg" style="height: 24px;">
      </div>
      <div class="col p-0 text-right">
        <button mat-mini-fab color="primary" (click)="$event.stopPropagation()" [matMenuTriggerFor]="menu" class="mat-elevation-z0">
          <i class="fal fa-user"></i>
        </button>
      </div>
    </div>
    <main class="main" [ngClass]="(renderNav$ | async) ? null : 'main--fullscreen'">
      <router-outlet></router-outlet>
    </main>
  </mat-sidenav-content>

  <mat-menu #menu="matMenu" class="mat-menu--account">
    <!--          <button mat-menu-item [routerLink]="'/users/accounts'">-->
    <button mat-menu-item>
      <i class="fal fa-user-circle"></i>
      <span class="mr-3">{{ user?.name}}</span>
    </button>
    <mat-divider *ngIf="publishers"></mat-divider>
    <button mat-menu-item disabled *ngIf="publishers">
      <span>Switch account</span>
    </button>
    <div>
      <span *ngFor="let pub of publishers">
        <button mat-menu-item (click)="openDashboard('publisher', pub.id)">
          <span class="ml-2">{{pub.name}}</span>
        </button>
      </span>
    </div>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="openChangePasswordDialog()" class="">
      <i class="fal fa-cogs"></i>
      <span class="ml-n1">Change password</span>
    </button>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="logout()" class="">
      <i class="fal fa-sign-out"></i>
      <span>Sign out</span>
    </button>
  </mat-menu>

  <mat-sidenav *ngIf="(renderNav$ | async)" [mode]="(screenWidth > 992) ? 'side' : 'over'" [opened]="isSideNavOpened$ | async"
               [class.sideOpened]="isSideNavOpened$ | async" [class.sideClosed]="(isSideNavOpened$ | async) === false" #sidenav>

    <div class="sidenav-header" *ngIf="user.network?.id === '3'">
      <img *ngIf="isSideNavOpened$ | async" style="height: 40px; margin: 0 auto; margin-top: 12px" src="../assets/img/logo-3.png"
           alt="">
      <img *ngIf="(isSideNavOpened$ | async) === false" style="height: 30px; margin-left: 125px; margin-top: 18px"
           src="../assets/img/logo-small-3.png" alt="">
    </div>

    <div class="sidenav-header d-none d-lg-flex" (click)="(screenWidth < 992) ? sideNavService.close() : ''">

      <div class="header-user">
        <button mat-mini-fab color="white" (click)="$event.stopPropagation()" [matMenuTriggerFor]="menu">
          {{getShortName(user.name)}}
        </button>
        <div class="header-user-info">
          <span class="user-info-name">{{user.name}}</span>
          <small class="user-info-role">{{user.roles}}</small>
        </div>
      </div>
      <ctv-sidenav-button *ngIf='isSideNavOpened$ | async'></ctv-sidenav-button>
    </div>

    <div class="sidenav-menu">

      <!-- NETWORK USER -->
      <mat-accordion class="app-nav-accordion" #accordionNetwork="matAccordion" [multi]="false" *ngIf="UI.isNetworkUser">

        <div *ngIf="UI.isNetworkUser" (click)="closeSidenavMobile(sidenav); closeAllNetworkExpansionsPanels();">
          <a class="sidenav-menu-item" routerLink="/dashboard" routerLinkActive="active">
            <i class="fal fa-tachometer-alt" matTooltip="Dashboard"></i>
            <span>Dashboard</span>
          </a>
        </div>

        <mat-expansion-panel *ngIf="UI.isNetworkUser" class="mat-elevation-z0" [expanded]="false">
          <mat-expansion-panel-header>
            <mat-panel-title class="sidenav-menu-item" >
              <i class="fal fa-clipboard-list-check" matTooltip="Apps"></i>
              <span>Inventory</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
            <li>
              <a routerLink="/placements" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Placements"></i>
                <span>Placements</span>
              </a>
            </li>
            <li>
              <a routerLink="/apps" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Apps"></i>
                <span>Apps</span>
              </a>
            </li>
            <li>
              <a routerLink="/supply-bundles" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Supply Bundles"></i>
                <span>Supply Bundles</span>
              </a>
            </li>
            <li>
              <a [routerLink]="['/', AppRoutePath.TARGETING]" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Targeting"></i>
                <span>Targeting</span>
              </a>
            </li>
            <li>
              <a routerLinkActive="active"
                 routerLink="/ads-txt">
                <i class="fas fa-circle" matTooltip="Ads.txt"></i>
                <span>Ads.txt</span>
              </a>
            </li>
          </ul>
        </mat-expansion-panel>

        <div *ngIf="UI.isNetworkUser" (click)="closeSidenavMobile(sidenav); closeAllNetworkExpansionsPanels()">
          <a class="sidenav-menu-item" routerLink="/publishers" routerLinkActive="active">
            <i class="fal fa-handshake" matTooltip="Publishers"></i>
            <span>Publishers</span>
          </a>
        </div>

        <mat-expansion-panel *ngIf="UI.isNetworkUser" class="mat-elevation-z0" [expanded]="false">
          <mat-expansion-panel-header>
            <mat-panel-title class="sidenav-menu-item">
              <i class="fal fa-user-tie"></i>
              Demand
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
            <li>
              <a routerLinkActive="active" routerLink="/demand/list">
                <i class="fas fa-circle" matTooltip="Partners"></i>
                <span>Partners</span>
              </a>
            </li>
            <li>
              <a routerLinkActive="active" routerLink="/connections">
                <i class="fas fa-circle" matTooltip="Connections"></i>
                <span>Connections</span>
              </a>
            </li>
            <li>
              <a routerLinkActive="active" routerLink="/deals">
                <i class="fas fa-circle" matTooltip="Deals"></i>
                <span>Deals</span>
              </a>
            </li>
          </ul>
        </mat-expansion-panel>

        <mat-expansion-panel class="mat-elevation-z0" [expanded]="false" *ngIf="UI.isNetworkUser">
          <mat-expansion-panel-header>
            <mat-panel-title class="sidenav-menu-item">
              <i class="fal fa-bullhorn" matTooltip="Apps"></i>
              Campaigns
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
            <li>
              <a routerLink="/advertiser" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Advertiser"></i>
                <span>Advertiser</span>
              </a>
            </li>
            <li>
              <a routerLink="/orders" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Campaigns"></i>
                <span>Campaigns</span>
              </a>
            </li>
            <li>
              <a routerLinkActive="active" routerLink="/line-items">
                <i class="fas fa-circle" matTooltip="Line items"></i>
                <span>Line Items</span>
              </a>
            </li>
            <li>
              <a [routerLink]="['/', AppRoutePath.CAMPAIGNS, AppRoutePath.CAMPAIGNS_CREATIVE_LIBRARY]"
                routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Campaigns creative library"></i>
                <span>Creatives</span>
              </a>
            </li>
          </ul>
        </mat-expansion-panel>

        <div *ngIf="UI.isNetworkUser" (click)="closeSidenavMobile(sidenav); closeAllNetworkExpansionsPanels()">
          <a class="sidenav-menu-item" routerLink="/reports" routerLinkActive="active">
            <i class="fal fa-chart-bar" matTooltip="Report builder"></i>
            <span>Reporting</span>
          </a>
        </div>

        <mat-expansion-panel *ngIf="UI.isNetworkUser" class="mat-elevation-z0" [expanded]="false">
          <mat-expansion-panel-header>
            <mat-panel-title class="sidenav-menu-item" >
              <i class="fal fa-tv-music" matTooltip="Audio to Video"></i>
              <span>A2V</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
            <li>
              <a routerLink="/assets" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Assets"></i>
                <span>Assets</span>
              </a>
            </li>
            <li>
              <a routerLink="/brands" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Brands"></i>
                <span>Brands</span>
              </a>
            </li>
            <li>
              <a routerLink="/network-template" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Network template"></i>
                <span>Network template</span>
              </a>
            </li>
          </ul>
        </mat-expansion-panel>

        <div *ngIf="UI.isNetworkUser" (click)="closeSidenavMobile(sidenav); closeAllNetworkExpansionsPanels();">
          <a class="sidenav-menu-item" routerLink="/changelog" routerLinkActive="active">
            <i class="fal fa-history" matTooltip="Changelog"></i>
            <span>Changelog</span>
          </a>
        </div>

        <div *ngIf="UI.isNetworkUser" (click)="closeSidenavMobile(sidenav); closeAllNetworkExpansionsPanels();">
          <a class="sidenav-menu-item" routerLink="/users" routerLinkActive="active">
            <i class="fal fa-users" matTooltip="Users"></i>
            <span>Users</span>
          </a>
        </div>
      </mat-accordion>
      <!--NETWORK USER END-->

      <!-- SALES REPRESENTATIVE USER -->
      <mat-accordion class="app-nav-accordion" #accordion="matAccordion" [multi]="false" *ngIf="UI.isSalesRep">

        <div (click)="closeSidenavMobile(sidenav); closeAllNetworkExpansionsPanels();">
          <a class="sidenav-menu-item" routerLink="/dashboard" routerLinkActive="active">
            <i class="fal fa-tachometer-alt" matTooltip="Dashboard"></i>
            <span>Dashboard</span>
          </a>
        </div>

        <mat-expansion-panel class="mat-elevation-z0" [expanded]="false">
          <mat-expansion-panel-header>
            <mat-panel-title class="sidenav-menu-item" >
              <i class="fal fa-clipboard-list-check" matTooltip="Apps"></i>
              <span>Inventory</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
            <li>
              <a routerLink="/apps" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Apps"></i>
                <span>Apps</span>
              </a>
            </li>
            <li>
              <a routerLinkActive="active"
                 routerLink="/ads-txt">
                <i class="fas fa-circle" matTooltip="Ads.txt"></i>
                <span>Ads.txt</span>
              </a>
            </li>
          </ul>
        </mat-expansion-panel>

        <div (click)="closeSidenavMobile(sidenav); closeAllExpansionsPanels();">
          <a class="sidenav-menu-item" routerLink="/publishers" routerLinkActive="active" (click)="closeSidenavMobile(sidenav); closeAllNetworkExpansionsPanels();">
            <i class="fal fa-handshake" matTooltip="Publishers"></i>
            <span>Publishers</span>
          </a>
        </div>

        <mat-expansion-panel class="mat-elevation-z0" [expanded]="false">
          <mat-expansion-panel-header>
            <mat-panel-title class="sidenav-menu-item">
              <i class="fal fa-analytics"></i>
              Analytics
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
            <li>
              <a routerLink="/reports" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Reporting"></i>
                <span>Report Builder</span>
              </a>
            </li>
            <li>
              <a routerLink="/performance" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Performance"></i>
                <span>Performance</span>
              </a>
            </li>
            <li *ngIf="pacingNavEnabled">
              <a [routerLink]="['/', AppRoutePath.ANALYTICS, AppRoutePath.ANALYTICS_PACING]"
                 routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Pacing"></i>
                <span>Pacing</span>
              </a>
            </li>
          </ul>
        </mat-expansion-panel>

        <div (click)="closeSidenavMobile(sidenav); closeAllExpansionsPanels();">
          <a class="sidenav-menu-item" routerLink="/changelog" routerLinkActive="active" (click)="closeSidenavMobile(sidenav); closeAllNetworkExpansionsPanels();">
            <i class="fal fa-history" matTooltip="Changelog"></i>
            <span>Changelog</span>
          </a>
        </div>

      </mat-accordion>
      <!-- SALES REPRESENTATIVE USER END-->

      <!-- CAMPAIGN MANAGER / CLIENT SERVICE MANAGER USER -->
      <mat-accordion class="app-nav-accordion" #accordion="matAccordion" [multi]="false" *ngIf="UI.isCampaignManager">

        <mat-expansion-panel class="mat-elevation-z0" [expanded]="false">
          <mat-expansion-panel-header>
            <mat-panel-title class="sidenav-menu-item" >
              <i class="fal fa-clipboard-list-check" matTooltip="Inventory"></i>
              <span>Inventory</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
            <li>
              <a routerLink="/supply-marketplace" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Supply Marketplace"></i>
                <span>Supply Marketplace</span>
              </a>
            </li>
            <li>
              <a routerLink="/forecast" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Forecast"></i>
                <span>Forecast</span>
              </a>
            </li>
            <li *ngIf="UI.isCampaignManager">
              <a [routerLink]="['/', AppRoutePath.TARGETING]" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Targeting"></i>
                <span>Targeting</span>
              </a>
            </li>
          </ul>
        </mat-expansion-panel>

        <mat-expansion-panel *ngIf="UI.isCampaignManager" class="mat-elevation-z0" [expanded]="false">
          <mat-expansion-panel-header>
            <mat-panel-title class="sidenav-menu-item">
              <i class="fal fa-user-tie"></i>
              Demand
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
            <li>
              <a routerLinkActive="active" routerLink="/deals">
                <i class="fas fa-circle" matTooltip="Deals"></i>
                <span>Deals</span>
              </a>
            </li>
          </ul>
        </mat-expansion-panel>

        <mat-expansion-panel class="mat-elevation-z0" [expanded]="false">
          <mat-expansion-panel-header>
            <mat-panel-title class="sidenav-menu-item">
              <i class="fal fa-bullhorn" matTooltip="Apps"></i>
              Campaigns
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
            <li>
              <a routerLink="/advertiser" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Advertisers"></i>
                <span>Advertisers</span>
              </a>
            </li>
            <li>
              <a routerLink="/orders" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Campaigns"></i>
                <span>Campaigns</span>
              </a>
            </li>
            <li>
              <a routerLinkActive="active" routerLink="/line-items">
                <i class="fas fa-circle" matTooltip="Line items"></i>
                <span>Line Items</span>
              </a>
            </li>
            <li>
              <a [routerLink]="['/', AppRoutePath.CAMPAIGNS, AppRoutePath.CAMPAIGNS_CREATIVE_LIBRARY]"
                 routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Campaigns creative library"></i>
                <span>Creatives</span>
              </a>
            </li>
          </ul>
        </mat-expansion-panel>

        <div (click)="closeSidenavMobile(sidenav); closeAllExpansionsPanels()">
          <a class="sidenav-menu-item" routerLink="/reports" routerLinkActive="active">
            <i class="fal fa-chart-bar" matTooltip="Report builder"></i>
            <span>Report Builder</span>
          </a>
        </div>
        <div *ngIf="pacingNavEnabled" (click)="closeSidenavMobile(sidenav); closeAllExpansionsPanels()">
          <a class="sidenav-menu-item" [routerLink]="['/', AppRoutePath.ANALYTICS, AppRoutePath.ANALYTICS_PACING]" routerLinkActive="active">
            <i class="fal fa-chart-line" matTooltip="Pacing"></i>
            <span>Pacing</span>
          </a>
        </div>
        <div (click)="closeSidenavMobile(sidenav); closeAllExpansionsPanels();">
          <a class="sidenav-menu-item" routerLink="/changelog" routerLinkActive="active">
            <i class="fal fa-history" matTooltip="Changelog"></i>
            <span>Changelog</span>
          </a>
        </div>
      </mat-accordion>
      <!-- CAMPAIGN MANAGER / CLIENT SERVICE MANAGER USER END-->

      <!-- REV OPS -->
      <mat-accordion class="app-nav-accordion" #accordion="matAccordion" [multi]="false" *ngIf="UI.isRevOps">

        <mat-expansion-panel class="mat-elevation-z0" [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title class="sidenav-menu-item" >
              <i class="fal fa-clipboard-list-check" matTooltip="Inventory"></i>
              <span>Inventory</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
            <li>
              <a routerLink="/supply-marketplace" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Supply Marketplace"></i>
                <span>Supply Marketplace</span>
              </a>
            </li>
            <li>
              <a routerLink="/forecast" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Forecast"></i>
                <span>Forecast</span>
              </a>
            </li>
            <li>
              <a routerLink="/publisher-keyword-translations" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Publisher Keyword Translations"></i>
                <span>Keyword Translations</span>
              </a>
            </li>
            <li>
              <a routerLink="/keywords" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Keywords"></i>
                <span>Keyword Packages</span>
              </a>
            </li>
            <li>
              <a routerLink="/supply-bundles" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Supply Bundles"></i>
                <span>Supply Bundles</span>
              </a>
            </li>
          </ul>
        </mat-expansion-panel>

        <mat-expansion-panel class="mat-elevation-z0" [expanded]="false">
          <mat-expansion-panel-header>
            <mat-panel-title class="sidenav-menu-item">
              <i class="fal fa-analytics"></i>
              Analytics
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
            <li>
              <a routerLink="/reports" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Reporting"></i>
                <span>Report Builder</span>
              </a>
            </li>
            <li *ngIf="pacingNavEnabled">
              <a [routerLink]="['/', AppRoutePath.ANALYTICS, AppRoutePath.ANALYTICS_PACING]"
                 routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Pacing"></i>
                <span>Pacing</span>
              </a>
            </li>
          </ul>
        </mat-expansion-panel>

      </mat-accordion>
      <!-- REV OPS END-->

      <!-- DESIGNER -->
      <mat-accordion class="app-nav-accordion" #accordion="matAccordion" [multi]="false" *ngIf="UI.isDesigner">

        <mat-expansion-panel class="mat-elevation-z0" [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title class="sidenav-menu-item">
              <i class="fal fa-bullhorn" matTooltip="Apps"></i>
              Campaigns
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
            <li>
              <a [routerLink]="['/', AppRoutePath.CAMPAIGNS, AppRoutePath.CAMPAIGNS_CREATIVE_LIBRARY]"
                 routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Campaigns creative library"></i>
                <span>Creatives</span>
              </a>
            </li>
          </ul>
        </mat-expansion-panel>

        <mat-expansion-panel *ngIf="pacingNavEnabled" class="mat-elevation-z0" [expanded]="false">
          <mat-expansion-panel-header>
            <mat-panel-title class="sidenav-menu-item">
              <i class="fal fa-analytics"></i>
              Analytics
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
            <li>
              <a [routerLink]="['/', AppRoutePath.ANALYTICS, AppRoutePath.ANALYTICS_PACING]"
                 routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Pacing"></i>
                <span>Pacing</span>
              </a>
            </li>
          </ul>
        </mat-expansion-panel>

      </mat-accordion>
      <!-- DESIGNER END-->

      <!-- ADMIN USER-->
      <mat-accordion class="app-nav-accordion" #accordion="matAccordion" [multi]="false" *ngIf="UI.isAdmin || UI.isReadonlyAdmin">

        <div *csHasNetworkPermission (click)="closeSidenavMobile(sidenav); closeAllExpansionsPanels();">
          <a class="sidenav-menu-item" routerLink="/dashboard" routerLinkActive="active">
            <i class="fal fa-tachometer-alt" matTooltip="Dashboard"></i>
            <span>Dashboard</span>
          </a>
        </div>

        <mat-expansion-panel *csHasNetworkPermission class="mat-elevation-z0" [expanded]="false">
          <mat-expansion-panel-header>
            <mat-panel-title class="sidenav-menu-item" >
              <i class="fal fa-clipboard-list-check" matTooltip="Inventory"></i>
              <span>Inventory</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
            <li>
              <a routerLink="/placements" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Placements"></i>
                <span>Placements</span>
              </a>
            </li>
            <li>
              <a routerLink="/apps" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Apps"></i>
                <span>Apps</span>
              </a>
            </li>
            <li>
              <a routerLink="/supply-marketplace" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Supply Marketplace"></i>
                <span>Supply Marketplace</span>
              </a>
            </li>
            <li>
              <a routerLink="/forecast" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Forecast"></i>
                <span>Forecast</span>
              </a>
            </li>
            <li>
              <a [routerLink]="['/', AppRoutePath.TARGETING]" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Targeting"></i>
                <span>Targeting</span>
              </a>
            </li>
            <li>
              <a routerLinkActive="active"
                 routerLink="/ads-txt">
                <i class="fas fa-circle" matTooltip="Ads.txt"></i>
                <span>Ads.txt</span>
              </a>
            </li>
            <li>
              <a routerLinkActive="active"
                 routerLink="/marketplace">
                <i class="fas fa-circle" matTooltip="Marketplace"></i>
                <span>Marketplace</span>
              </a>
            </li>
            <li>
              <a routerLinkActive="active"
                 routerLink="/taxonomy">
                <i class="fas fa-circle" matTooltip="Taxonomy"></i>
                <span>Taxonomy</span>
              </a>
            </li>
            <li>
              <a routerLinkActive="active"
                 routerLink="/marketplace-routing">
                <i class="fas fa-circle" matTooltip="Marketplace Routing"></i>
                <span>Marketplace Routing</span>
              </a>
            </li>
            <li>
              <a routerLink="/publisher-keyword-translations" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Publisher Keyword Translations"></i>
                <span>Keyword Translations</span>
              </a>
            </li>
            <li>
              <a routerLink="/keywords" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Keywords"></i>
                <span>Keyword Packages</span>
              </a>
            </li>
            <li>
              <a routerLink="/channel-bundles" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Keywords"></i>
                <span>Channel Bundles</span>
              </a>
            </li>
            <li>
              <a routerLink="/supply-bundles" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Supply Bundles"></i>
                <span>Supply Bundles</span>
              </a>
            </li>
          </ul>
        </mat-expansion-panel>

        <mat-expansion-panel class="mat-elevation-z0" *csHasNetworkPermission [expanded]="false">
          <mat-expansion-panel-header>
            <mat-panel-title class="sidenav-menu-item">
              <i class="fal fa-handshake"></i>
              Partners
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
            <li>
              <a routerLink="/publishers" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Publishers"></i>
                <span>Publishers</span>
              </a>
            </li>
            <li>
              <a routerLink="/networks" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Network"></i>
                <span>Network</span>
              </a>
            </li>
          </ul>
        </mat-expansion-panel>

        <mat-expansion-panel *csHasNetworkPermission class="mat-elevation-z0" [expanded]="false">
          <mat-expansion-panel-header>
            <mat-panel-title class="sidenav-menu-item">
              <i class="fal fa-user-tie"></i>
              Demand
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
            <li>
              <a routerLinkActive="active" routerLink="/demand/list">
                <i class="fas fa-circle" matTooltip="Partners"></i>
                <span>Partners</span>
              </a>
            </li>
            <li>
              <a routerLinkActive="active" routerLink="/connections">
                <i class="fas fa-circle" matTooltip="Connections"></i>
                <span>Connections</span>
              </a>
            </li>
            <li>
              <a routerLinkActive="active" routerLink="/deals">
                <i class="fas fa-circle" matTooltip="Deals"></i>
                <span>Deals</span>
              </a>
            </li>
            <li>
              <a routerLinkActive="active" routerLink="/demand/compliance">
                <i class="fas fa-circle" matTooltip="Compliance"></i>
                <span>Compliance</span>
              </a>
            </li>
            <li>
              <a routerLinkActive="active" routerLink="/demand/discrepancies">
                <i class="fas fa-circle" matTooltip="Compliance"></i>
                <span>Discrepancies</span>
              </a>
            </li>
          </ul>
        </mat-expansion-panel>

        <mat-expansion-panel class="mat-elevation-z0" *csHasNetworkPermission [expanded]="false">
          <mat-expansion-panel-header>
            <mat-panel-title class="sidenav-menu-item">
              <i class="fal fa-bullhorn" matTooltip="Apps"></i>
              Campaigns
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
            <li>
              <a routerLink="/advertiser" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Advertisers"></i>
                <span>Advertisers</span>
              </a>
            </li>
            <li>
              <a routerLink="/orders" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Campaigns"></i>
                <span>Campaigns</span>
              </a>
            </li>
            <li>
              <a routerLinkActive="active" routerLink="/line-items">
                <i class="fas fa-circle" matTooltip="Line items"></i>
                <span>Line Items</span>
              </a>
            </li>
            <li>
              <a [routerLink]="['/', AppRoutePath.CAMPAIGNS, AppRoutePath.CAMPAIGNS_CREATIVE_LIBRARY]"
                 routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Campaigns creative library"></i>
                <span>Creatives</span>
              </a>
            </li>
          </ul>
        </mat-expansion-panel>

        <mat-expansion-panel class="mat-elevation-z0" [expanded]="false" *csHasNetworkPermission>
          <mat-expansion-panel-header>
            <mat-panel-title class="sidenav-menu-item" routerLink="/sources">
              <i class="fal fa-users-class" matTooltip="Apps"></i>
              Squeezeback
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
            <li>
              <a routerLink="/sources" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Sources"></i>
                <span>Sources</span>
              </a>
            </li>
          </ul>
        </mat-expansion-panel>

        <mat-expansion-panel class="mat-elevation-z0" [expanded]="false" *csHasNetworkPermission>
          <mat-expansion-panel-header>
            <mat-panel-title class="sidenav-menu-item">
              <i class="fal fa-analytics"></i>
              Analytics
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
            <li>
              <a routerLink="/reports" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Reporting"></i>
                <span>Report Builder</span>
              </a>
            </li>
            <li>
              <a routerLink="/performance" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Performance"></i>
                <span>Performance</span>
              </a>
            </li>
            <li *ngIf="pacingNavEnabled">
              <a [routerLink]="['/', AppRoutePath.ANALYTICS, AppRoutePath.ANALYTICS_PACING]"
                 routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Pacing"></i>
                <span>Pacing</span>
              </a>
            </li>
            <li>
              <a routerLink="/scheduled-reports" routerLinkActive="active" *csHasPermission="RolePermission.RB_SCHEDULE_CREATE">
                <i class="fas fa-circle" matTooltip="Scheduled reports"></i>
                <span>Scheduled Reports</span>
              </a>
            </li>
            <!-- Decided to remove on 09/06/2022 by Martin, Dario and Bogdan-->
            <!--<li *csHasNetworkPermission>
              <a routerLink="/custom-reports" routerLinkActive="active" *csHasPermission="RolePermission.CUSTOM_REPORTS_CREATE">
                <i class="fas fa-circle" matTooltip="Custom reports"></i>
                <span>Custom Reports</span>
              </a>
            </li>-->
            <!-- <li>
              <a [routerLink]="['/', AppRoutePath.ERRORS]" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Errors"></i>
                <span>Error Reports</span>
              </a>
            </li> -->
          </ul>
        </mat-expansion-panel>

        <mat-expansion-panel *csHasNetworkPermission class="mat-elevation-z0" [expanded]="false">
          <mat-expansion-panel-header>
            <mat-panel-title class="sidenav-menu-item" >
              <i class="fal fa-tv-music" matTooltip="Audio to Video"></i>
              <span>A2V</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
            <li>
              <a routerLink="/assets" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Assets"></i>
                <span>Assets</span>
              </a>
            </li>
            <li>
              <a routerLink="/brands" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Brands"></i>
                <span>Brands</span>
              </a>
            </li>
            <li>
              <a routerLink="/network-template" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Network template"></i>
                <span>Network template</span>
              </a>
            </li>
          </ul>
        </mat-expansion-panel>

        <div *csHasNetworkPermission (click)="closeSidenavMobile(sidenav); closeAllExpansionsPanels();">
          <a class="sidenav-menu-item" routerLink="/changelog" routerLinkActive="active">
            <i class="fal fa-history" matTooltip="Changelog"></i>
            <span>Changelog</span>
          </a>
        </div>

        <mat-expansion-panel class="mat-elevation-z0" [expanded]="false" *csHasNetworkPermission>
          <mat-expansion-panel-header>
            <mat-panel-title class="sidenav-menu-item">
              <i class="fal fa-file-video"></i>
              Content
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
            <li>
              <a routerLink="/owned-operated-apps" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Apps"></i>
                <span>O&O Apps</span>
              </a>
            </li>
            <li>
              <a routerLink="/collections" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Collections"></i>
                <span>Collections</span>
              </a>
            </li>
            <li>
              <a routerLink="/videos" routerLinkActive="active">
                <i class="fas fa-circle" matTooltip="Videos"></i>
                <span>Videos</span>
              </a>
            </li>
            <li>
              <a routerLinkActive="active" routerLink="/content-owner">
                <i class="fas fa-circle" matTooltip="Content owners"></i>
                <span>Content Owners</span>
              </a>
            </li>
          </ul>
        </mat-expansion-panel>

      <div *csHasNetworkPermission (click)="closeSidenavMobile(sidenav); closeAllExpansionsPanels();">
        <a class="sidenav-menu-item"  routerLink="/users" routerLinkActive="active">
          <i class="fal fa-users" matTooltip="Users"></i>
          <span>Users</span>
        </a>
      </div>
      </mat-accordion>
      <!-- ADMIN USER END-->

    </div>

  </mat-sidenav>
</mat-sidenav-container>
